import { render, staticRenderFns } from "./GLineupItemGroup.vue?vue&type=template&id=76c833d0&scoped=true&"
import script from "./GLineupItemGroup.vue?vue&type=script&lang=ts&"
export * from "./GLineupItemGroup.vue?vue&type=script&lang=ts&"
import style0 from "./GLineupItemGroup.vue?vue&type=style&index=0&id=76c833d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c833d0",
  null
  
)

export default component.exports